import { useState } from "react"
import { FaEnvelope, FaFacebook, FaTelegram, FaTwitterSquare } from 'react-icons/fa'
import { reactLocalStorage } from "reactjs-localstorage"
import { Avatar } from "../../../assets"
import { LoaderSpinner } from "../../atoms";
import { useNavigate } from "react-router-dom";

const StepThree = () => {
  const [imagePreview, setImagePreview] = useState(Avatar)
  const [tokenLogo, setTokenLogo] = useState('')
  const [twitter, setTwitter] = useState('')
  const [facebook, setFacebook] = useState('')
  const [telegram, setTelegram] = useState('')
  const [ownerEmail, setownerEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()
  const handlePreviewImage = (e) => {
    setImagePreview(URL.createObjectURL(e.target.files[0]))
    var file = e.target.files[0];
    var reader = new FileReader();
    reader.onloadend = function () {
      setTokenLogo(reader.result)
    }
    reader.readAsDataURL(file);
  }
  const handleNext = () => {
    setIsLoading(true)
    const formTwo = reactLocalStorage.getObject('formData');
    reactLocalStorage.setObject('formData', {
      tokenLogo,
      twitter,
      facebook,
      telegram,
      ownerEmail,
      ...formTwo
    })
    navigate('/create?step=4')
    setIsLoading(false)
  }
  return (
    <>
      <div className="step-info">
        <h3 className="step-title">Additional Information</h3>
      </div>
      <div className="form-step">
        <div className="imagePreview">
          <label htmlFor="addAvatar" className="addAvatar">
            <img src={imagePreview} alt="avatar" className="img" />
            <div className="iconAdd">+</div>
          </label>
          <input type="file" id="addAvatar" onChange={handlePreviewImage} className="d-none" />
        </div>

        <div className="input-wrapper">
          <FaTwitterSquare />
          <input value={twitter} onChange={(e) => setTwitter(e.target.value)} type="text" className="input-token" placeholder="Twitter" />
        </div>
        <div className="input-wrapper">
          <FaFacebook />
          <input value={facebook} onChange={(e) => setFacebook(e.target.value)} type="text" className="input-token" placeholder="Facebook" />
        </div>
        <div className="input-wrapper">
          <FaTelegram />
          <input value={telegram} onChange={(e) => setTelegram(e.target.value)} type="text" className="input-token" placeholder="Telegram" />
        </div>
        <div className="input-wrapper">
        <span className="isRequired">*</span>
          <FaEnvelope />
          <input value={ownerEmail} onChange={(e) => setownerEmail(e.target.value)} type="email" className="input-token" placeholder="Owner Email" />
        </div>
      </div>
      <div className="action-next">
        {/* <Link className="next-link" to="/create?step=4">NEXT</Link> */}
        <button className="next-link" onClick={handleNext}>NEXT</button>
      </div>
      {
        isLoading && <LoaderSpinner />
      }
    </>
  )
}

export default StepThree
